(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["mvh-popover-style"] && !Shopify.designMode) return;
  try {
    document.addEventListener('click',function(event){if(event.target.closest('a.icon-cart,a[href="#account-popup"]')){document.querySelectorAll('.mvh-search-toggle[open],.mvh-products-toggle[open]').forEach(panel=>panel.open=false);const header=event.target.closest('header');if(header)document.documentElement.style.setProperty('--mvh-popover-top',Math.max(0,header.getBoundingClientRect().bottom)+'px');}},true);
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["mvh-products-menu"] && !Shopify.designMode) return;
  try {
    if(!customElements.get('mvh-products-menu'))customElements.define('mvh-products-menu',class extends HTMLElement{
connectedCallback(){
 if(this.events)this.events.abort();
 this.events=new AbortController();
 const options={signal:this.events.signal},mobile=this.closest('.mvh-products-nav--mobile');
 if(mobile){
  this.querySelectorAll('details').forEach(details=>{
   const summary=details.querySelector(':scope > summary'),group=document.createElement('div'),button=document.createElement('button'),panel=document.createElement('div');
   group.className=details.className;
   button.type='button';
   button.className=summary.className+' mvh-menu-button';
   button.innerHTML=summary.innerHTML;
   button.setAttribute('aria-expanded','false');
   panel.hidden=true;
   Array.from(details.childNodes).forEach(child=>{if(child!==summary)panel.appendChild(child);});
   group.append(button,panel);
   details.replaceWith(group);
  });
 }
 const outer=this.querySelector('.mvh-products-toggle'),trigger=outer.firstElementChild;
 const close=()=>{
  if(mobile){trigger.setAttribute('aria-expanded','false');outer.setAttribute('aria-expanded','false');trigger.nextElementSibling.hidden=true;}
  else outer.open=false;
 };
 this.addEventListener('click',e=>{
  const button=e.target.closest('.mvh-menu-button');
  if(mobile&&button&&this.contains(button)){
   const open=button.getAttribute('aria-expanded')!=='true';
   button.setAttribute('aria-expanded',String(open));
   button.parentElement.setAttribute('aria-expanded',String(open));
   button.nextElementSibling.hidden=!open;
  }else if(!mobile&&e.target.closest('.mvh-products-group>summary'))e.preventDefault();
 },options);
 this.addEventListener('keydown',e=>{if(e.key==='Escape'){close();trigger.focus();}},options);
 if(!mobile)this.addEventListener('focusout',e=>{if(e.relatedTarget&&!this.contains(e.relatedTarget))close();},options);
 document.addEventListener('click',e=>{if(!this.contains(e.target))close();},options);
}
disconnectedCallback(){if(this.events)this.events.abort();}
});
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["rsr-card"] && !Shopify.designMode) return;
  try {
    if (!customElements.get('rsr-catalog-rating')) {
  const requests = new Map();
  customElements.define('rsr-catalog-rating', class extends HTMLElement {
    connectedCallback() {
      if (this.loaded) return;
      this.loaded = true;
      const url = `${this.dataset.root}apps/mvh-reviews?${new URLSearchParams({product: this.dataset.product, page: '1'})}`;
      if (!requests.has(url)) requests.set(url, fetch(url).then(response => {
        if (!response.ok) throw new Error('Reviews unavailable');
        return response.json();
      }));
      requests.get(url).then(data => {
        const count = Number(data.count), average = Number(data.average);
        if (!Number.isInteger(count) || count < 0 || !Number.isFinite(average) || average < 0 || average > 5) return;
        const stars = document.createElement('span');
        stars.className = 'rsr-rating-stars';
        stars.setAttribute('aria-hidden', 'true');
        stars.textContent = '★★★★★';
        stars.style.setProperty('--rating-fill', `${count ? average * 20 : 0}%`);
        const text = document.createElement('span');
        text.textContent = count ? `${average.toFixed(1)} / 5 · ${count} ${count === 1 ? this.dataset.singular : this.dataset.label}` : this.dataset.empty;
        this.replaceChildren(stars, text);
        this.hidden = false;
      }).catch(() => { this.hidden = true; });
    }
  });
}
  } catch(e) { console.error(e); }
})();

})();
